import { Container } from 'ui/container'
import { LeaderboardAdmin } from 'features/admin/leaderboard'
import { Link } from 'react-router-dom'
import { routes } from 'core/routes/paths'

import c from '../assets/sass/page.module.scss'

const AdminLeaderboardPage = () => {
    return (
        <div className={c.component}>
            <div className={c.header}>
                <Link to={routes.admin} className={c.back}>
                    ← Назад
                </Link>
                <span className={c.title}>Лидерборд</span>
            </div>
            <Container>
                <LeaderboardAdmin />
            </Container>
        </div>
    )
}

export default AdminLeaderboardPage
